<template>
  <div>
     <div class="unishop-item-photo">
        <div class="unishop-item-thumbs unishop-thumbs-multiple" @mouseover="isHovering = true" @mouseout="isHovering = false" 
            :class="{'unishop-thumbs-hover': isHovering && fotoSecundaria !==''}">
          <a class="unishop-modal-link">
              <img v-if="fotoDefecto !==''" :src="fotoDefecto" :alt="product.descripcion">
              <img v-else src='@/assets/images/noimg.jpg' :alt="product.descripcion">
          </a>
          <a class="unishop-modal-link">
            <img v-if="fotoSecundaria !==''" :src="fotoSecundaria" :alt="product.descripcion">
          </a>
        </div>
        <!-- <div class="unishop-sale-discount">50% off</div> -->
      </div>
      <div class="unishop-item-name w-100 pt-2">
          <h2 class="primary-color h5 text-uppercase mb-0 font-weight-medium">{{ product.modelo }}</h2>  
          <p class="d-flex mb-0">{{ product.color }}<span class="no-flex my-0 h5 ml-auto floar-right font-weight-black"> {{ precio }} €</span></p>
        <!-- <div class="unishop-rating">
          <span v-if="product.ratings >= 1" class="unishop-star"></span>
          <span v-if="product.ratings >= 2" class="unishop-star"></span>
          <span v-if="product.ratings >= 3" class="unishop-star"></span>
          <span v-if="product.ratings >= 4" class="unishop-star"></span>
          <span v-if="product.ratings >= 5" class="unishop-star"></span>
        </div> -->
      </div>
  </div>
</template>

<script>
import { TiendaApiService } from '@/api/TiendaApiService'
import { Util } from '@/api/Util'

const tiendaApiService = new TiendaApiService()
const util = new Util()

export default {
  name: 'products',
  props: ['product','opId'],

  data () {
    return {
      selected: 1,
      isHovering: false,
      fotoDefecto: '',
      fotoSecundaria: '',
      precio: ''
    }
  },

  mounted () {
    this.init()
    
  },

  computed: {
    isUserLogged () {
      return this.$store.getters.isUserLoggedIn;
    }
  },

  methods: {
    init() {
      this.getFotos()
      this.getPrecio()
      // this.getPrecios()
    },
    // getPrecios(){
    //   tiendaApiService.getPreciosByIdArtandIdOp(this.product.id)
    //     .then(data => {
    //       // util.mostrarEnConsola('tiendaApiService - getPreciosByIdArtandIdOp', data.length, 'OK')
    //       //console.log(data)
    //       this.precios = data 
    //       this.getPrecio()
    //     })
    //     .catch(error => {
          
    //       util.mostrarEnConsola('tiendaApiService - getPreciosByIdArtandIdOp', error, 'ERROR')
    //     })

    // },
    getPrecio() {
      // si queremos sacar el precio de la tienda
      outer_loop:
      for (var i = 0; i < this.product.tallas.length; i++) {
        for (var y = 0; y < this.product.tallas[i].stocks.length; y++) {
          if (this.product.tallas[i].stocks[y].precio) {
            this.precio=this.product.tallas[i].stocks[y].precio.precio
            if (this.product.tallas[i].stocks[y].id.id_op == this.opId) {
              break outer_loop
            } 
          }
        }
      }
    },
    getFotos() {
      if (this.product.fotos) {
        this.product.fotos.forEach(element =>{
          if (element.porDefecto === "S") {
            if (element.url && !this.isSys4Conjunto()) {
              this.fotoDefecto = element.url
            } else if (element.imagenBytes) {
              this.fotoDefecto = ("data:image/png;base64," + element.imagenBytes)
            }
          } else {
            if (element.url && !this.isSys4Conjunto()) {
              this.fotoSecundaria=element.url
              if (this.fotoDefecto === '') {
                this.fotoDefecto = this.fotoSecundaria
              }
            } else if (element.imagenBytes) {
               this.fotoSecundaria = ("data:image/png;base64," + element.imagenBytes)
            }
          }
        })
        if (this.fotoDefecto === null) {
          this.fotoDefecto = ''
        }
      } 
    },
  }
}
</script>



